import React from 'react';

const SvgSb = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="SB_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="SB_svg__b">
        <stop stopColor="#1DBE4F" offset="0%" />
        <stop stopColor="#159B3F" offset="100%" />
      </linearGradient>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="SB_svg__f">
        <stop stopColor="#0660D4" offset="0%" />
        <stop stopColor="#0051BB" offset="100%" />
      </linearGradient>
      <path id="SB_svg__e" d="M0 0h28L0 20z" />
      <filter
        x="-5.4%"
        y="-7.5%"
        width="118.3%"
        height="119.7%"
        filterUnits="objectBoundingBox"
        id="SB_svg__d"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="SB_svg__c" fill="#fff">
        <use xlinkHref="#SB_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#SB_svg__a" />
      <path fill="url(#SB_svg__b)" mask="url(#SB_svg__c)" d="M0 0h28v20H0z" />
      <g mask="url(#SB_svg__c)">
        <use fill="#000" filter="url(#SB_svg__d)" xlinkHref="#SB_svg__e" />
        <use fill="url(#SB_svg__f)" xlinkHref="#SB_svg__e" />
      </g>
      <path
        fill="#2C7442"
        mask="url(#SB_svg__c)"
        transform="matrix(-1 0 0 1 28 0)"
        d="M0 0l28 20H0z"
      />
      <path
        fill="#FFD646"
        mask="url(#SB_svg__c)"
        d="M-5.333 8.667h38.667v2.667H-5.333z"
      />
      <path
        d="M3 3.833l-.98.515.187-1.09-.792-.773 1.095-.16.49-.992.49.993 1.095.159-.792.773.187 1.09L3 3.833zm6.667 0l-.98.515.187-1.09-.792-.773 1.095-.16.49-.992.49.993 1.095.159-.793.773.187 1.09-.98-.515zm0 4l-.98.515.187-1.09-.792-.773 1.095-.16.49-.992.49.993 1.095.159-.793.773.187 1.09-.98-.515zM3 7.833l-.98.515.187-1.09-.792-.773 1.095-.16.49-.992.49.993 1.095.159-.792.773.187 1.09L3 7.833zm3.333-2l-.98.515.188-1.09-.793-.773 1.096-.16.49-.992.49.993 1.094.159-.792.773.187 1.09-.98-.515z"
        fill="#FFF"
        mask="url(#SB_svg__c)"
      />
    </g>
  </svg>
);

export default SvgSb;
